export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  cover: string;
  category: '影视新闻' | '生活动态' | '活动报道';
  publishDate: string;
  hot: number;
  tags: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'news-001',
    title: '张柏芝新片路演收官，现场分享拍摄幕后故事',
    summary: '张柏芝携新作品展开全国路演，在多座城市与影迷面对面交流，畅谈角色塑造与拍摄中的难忘瞬间。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20asian%20actress%20on%20stage%20at%20film%20premiere%20event%2C%20warm%20spotlight%2C%20dark%20navy%20stage%20background%2C%20professional%20editorial%20photography%2C%20soft%20glow%2C%20cinematic%20mood&width=800&height=500&seq=news001-01&orientation=landscape',
    category: '影视新闻',
    publishDate: '2026-10-12',
    hot: 9821,
    tags: ['新片路演', '幕后花絮'],
  },
  {
    id: 'news-002',
    title: '张柏芝出席慈善晚宴，呼吁关注儿童教育公益',
    summary: '张柏芝受邀出席年度慈善晚宴，呼吁社会各界关注儿童教育公益事业，并现场捐赠善款支持相关项目。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20asian%20woman%20in%20evening%20gown%20at%20charity%20gala%2C%20soft%20warm%20lighting%2C%20navy%20and%20gold%20tones%2C%20editorial%20portrait%20photography%2C%20graceful%20pose&width=800&height=500&seq=news002-01&orientation=landscape',
    category: '活动报道',
    publishDate: '2026-10-10',
    hot: 7342,
    tags: ['公益活动', '慈善晚宴'],
  },
  {
    id: 'news-003',
    title: '张柏芝晒日常生活照，状态松弛引网友热议',
    summary: '张柏芝在社交平台分享近期生活照片，状态轻松自然，网友纷纷留言称赞其气色佳、心态好。',
    cover: 'https://readdy.ai/api/search-image?query=relaxed%20asian%20woman%20casual%20lifestyle%20portrait%2C%20natural%20daylight%2C%20cozy%20home%20interior%2C%20soft%20neutral%20tones%2C%20candid%20editorial%20photography&width=800&height=500&seq=news003-01&orientation=landscape',
    category: '生活动态',
    publishDate: '2026-10-08',
    hot: 6520,
    tags: ['生活日常', '近况'],
  },
  {
    id: 'news-004',
    title: '张柏芝新剧开机仪式举行，合作阵容首次曝光',
    summary: '张柏芝主演的新剧于近日举行开机仪式，制作团队及合作演员阵容首次公开，备受期待。',
    cover: 'https://readdy.ai/api/search-image?query=film%20set%20clapperboard%20ceremony%20with%20asian%20actress%2C%20studio%20lighting%2C%20deep%20navy%20blue%20backdrop%2C%20professional%20behind%20the%20scenes%20photography&width=800&height=500&seq=news004-01&orientation=landscape',
    category: '影视新闻',
    publishDate: '2026-10-05',
    hot: 5890,
    tags: ['新剧开机', '合作阵容'],
  },
  {
    id: 'news-005',
    title: '张柏芝接受专访，畅谈二十年演艺心路历程',
    summary: '在最新专访中，张柏芝回顾了自己二十余年的演艺生涯，分享对表演的理解与未来的创作规划。',
    cover: 'https://readdy.ai/api/search-image?query=asian%20actress%20interview%20portrait%2C%20studio%20setting%2C%20warm%20orange%20accent%20light%2C%20navy%20background%2C%20professional%20magazine%20style%20photography&width=800&height=500&seq=news005-01&orientation=landscape',
    category: '影视新闻',
    publishDate: '2026-10-01',
    hot: 8120,
    tags: ['专访', '演艺生涯'],
  },
  {
    id: 'news-006',
    title: '张柏芝出席品牌活动，优雅造型引发关注',
    summary: '张柏芝受邀出席品牌年度活动，当晚造型优雅大方，成为现场焦点，相关话题迅速登上热搜。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20asian%20celebrity%20at%20brand%20event%20red%20carpet%2C%20soft%20studio%20lighting%2C%20navy%20blue%20and%20warm%20gold%20tones%2C%20editorial%20fashion%20photography&width=800&height=500&seq=news006-01&orientation=landscape',
    category: '活动报道',
    publishDate: '2026-09-28',
    hot: 4980,
    tags: ['品牌活动', '造型'],
  },
];